import { Button, Modal, StateIcon } from '@unified-checkout/design-system';
import { Xmark } from '@unified-checkout/design-system/icons/index';

type ClickErrorLoginModalProps = {
  isOpen: boolean;
  retryHandler: () => void;
};
export const ClickErrorLoginModal = ({
  isOpen,
  retryHandler,
}: ClickErrorLoginModalProps) => {
  return (
    <Modal open={isOpen} width="25rem">
      <div className="flex flex-col items-center">
        <StateIcon icon={Xmark} status="error" />
        <h2>Your account creation was unsuccessful</h2>
        <p>This is a supporting text</p>
        <Button text="retry" onClickHandler={retryHandler} />
      </div>
    </Modal>
  );
};
